/**
 * xp-color-theme.js
 * Swaps product images and videos between white/black variants
 * when clicking color dots in xp-features or xp-compare.
 */
(function () {
  'use strict';

  var KEY = 'xp-color-theme';

  function setColor(color) {
    // Mark active dots
    document.querySelectorAll('.xp-color-dot, .xp-compare__dot').forEach(function (d) {
      d.classList.remove('xp-color-dot--active');
    });
    var suffix = color === 'black' ? '--black' : '--white';
    document.querySelectorAll(
      '.xp-color-dot' + suffix + ', .xp-compare__dot' + suffix
    ).forEach(function (d) {
      d.classList.add('xp-color-dot--active');
    });

    // Swap images with soft fade — preload first so it stays in sync with videos
    var imgs = document.querySelectorAll('.xp-color-swap');
    imgs.forEach(function (img) {
      var src = img.getAttribute('data-color-' + color + '-src');
      var srcset = img.getAttribute('data-color-' + color + '-srcset');
      if (!src) return;

      // Start fade-out immediately
      img.classList.add('is-swapping');

      // Preload the new image in parallel with the fade-out
      var preloader = new Image();
      var preloadReady = false;
      var onReady = function () { preloadReady = true; };
      preloader.onload = onReady;
      preloader.onerror = onReady;
      if (srcset) preloader.srcset = srcset;
      preloader.src = src;

      // Wait for BOTH the fade-out (550ms) and the image preload to finish
      var elapsed = 0;
      var swapped = false;
      var doSwap = function () {
        if (swapped) return;
        swapped = true;
        img.setAttribute('src', src);
        if (srcset) img.setAttribute('srcset', srcset);
        // Force the browser to commit the src change, then fade back in
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            img.classList.remove('is-swapping');
          });
        });
      };

      // Try at 550ms (fade-out done). If image not loaded yet, poll until it is.
      setTimeout(function tick () {
        if (preloadReady || preloader.complete) {
          doSwap();
        } else {
          elapsed += 30;
          if (elapsed > 1500) { doSwap(); return; } // safety fallback
          setTimeout(tick, 30);
        }
      }, 550);
    });

    // Swap hero videos (white ↔ black)
    swapHeroVideos(color);

    try { sessionStorage.setItem(KEY, color); } catch (e) {}
  }

  function swapHeroVideos(color) {
    var showWhite = color !== 'black';
    var whiteSelectors = '.xp-hero__media--white, .xp-feature-card__media--white, .xp-specs__media--white';
    var blackSelectors = '.xp-hero__media--black, .xp-feature-card__media--black, .xp-specs__media--black';
    var whites = document.querySelectorAll(whiteSelectors);
    var blacks = document.querySelectorAll(blackSelectors);
    if (!whites.length && !blacks.length) return;

    var toShow = showWhite ? whites : blacks;
    var toHide = showWhite ? blacks : whites;

    // Soft fade-out → swap → fade-in
    toHide.forEach(function (v) {
      if (v.style.display !== 'none') {
        v.classList.add('xp-video-fading');
      }
    });

    setTimeout(function () {
      toHide.forEach(function (v) {
        v.style.display = 'none';
        v.classList.remove('xp-video-fading');
      });
      // Incoming videos: hidden via class, then made visible, then fade in
      toShow.forEach(function (v) {
        v.classList.add('xp-video-fading');
        v.style.display = '';
        if (v.play) { try { v.play(); } catch (e) {} }
      });
      requestAnimationFrame(function () {
        toShow.forEach(function (v) {
          v.classList.remove('xp-video-fading');
        });
      });
    }, 550);

    // For specs: ensure the active spec stays active in the new color variant
    document.querySelectorAll('.xp-specs__media--active').forEach(function (v) {
      var idx = v.getAttribute('data-spec-index');
      if (idx === null) return;
      var section = v.closest('.xp-specs');
      if (!section) return;
      var wantedColor = showWhite ? 'white' : 'black';
      var preferred = section.querySelector('.xp-specs__media--' + wantedColor + '[data-spec-index="' + idx + '"]');
      if (preferred && preferred !== v) {
        v.classList.remove('xp-specs__media--active');
        preferred.classList.add('xp-specs__media--active');
      }
    });
  }

  function init() {
    var saved;
    try { saved = sessionStorage.getItem(KEY); } catch (e) {}
    // Apply saved choice (no animation on first load)
    var activeColor = saved === 'black' ? 'black' : 'white';
    swapHeroVideos(activeColor);
    if (saved === 'black') {
      document.querySelectorAll('.xp-color-swap').forEach(function (img) {
        var src = img.getAttribute('data-color-black-src');
        var srcset = img.getAttribute('data-color-black-srcset');
        if (src) {
          img.setAttribute('src', src);
          if (srcset) img.setAttribute('srcset', srcset);
        }
      });
      document.querySelectorAll('.xp-color-dot--black, .xp-compare__dot--black').forEach(function (d) {
        d.classList.add('xp-color-dot--active');
      });
    } else {
      document.querySelectorAll('.xp-color-dot--white, .xp-compare__dot--white').forEach(function (d) {
        d.classList.add('xp-color-dot--active');
      });
    }

    // Bind clicks (works on both desktop and mobile)
    var handleDotActivate = function (target) {
      var isBlack = target.classList.contains('xp-color-dot--black') || target.classList.contains('xp-compare__dot--black');
      var isWhite = target.classList.contains('xp-color-dot--white') || target.classList.contains('xp-compare__dot--white');
      if (!isBlack && !isWhite) return;

      // Click pulse on the dot
      target.classList.remove('is-clicked');
      void target.offsetWidth;
      target.classList.add('is-clicked');
      setTimeout(function () { target.classList.remove('is-clicked'); }, 700);

      setColor(isBlack ? 'black' : 'white');
    };

    document.addEventListener('click', function (e) {
      handleDotActivate(e.target);
    });

    // iOS sometimes drops click on non-button spans — listen to touchend as a fallback
    document.addEventListener('touchend', function (e) {
      var t = e.target;
      if (
        t.classList.contains('xp-color-dot--black') ||
        t.classList.contains('xp-color-dot--white') ||
        t.classList.contains('xp-compare__dot--black') ||
        t.classList.contains('xp-compare__dot--white')
      ) {
        e.preventDefault(); // prevent the synthetic click from firing twice
        handleDotActivate(t);
      }
    }, { passive: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
